import Vue from "vue";
import VueRouter from "vue-router";
import { store } from "../store";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Dashboard from "../views/Dashboard.vue";
import WindowFrame from "../components/WINDOWFRAME/WindowFrame.vue";
import MicroTest from "../views/_microtest/MicroTest.vue";
import Notifiche from "@/views/NOTIFICA/Notifiche.vue";
import MacchinaNuovo from "@/views/PRODUCTION/Macchine/MacchinaNuovo.vue";


import GestioneProfilo from "../views/IMPOSTAZIONI/GestioneProfilo.vue";
import GestioneModelliDocumento from "../views/IMPOSTAZIONI/GestioneModelloDocumento.vue";
import GestioneAzienda from "../views/IMPOSTAZIONI/GestioneAzienda.vue";
import GestioneUtentiSettings from "../views/IMPOSTAZIONI/GestioneUtenti.vue";
import GestioneModificheDB from "../views/IMPOSTAZIONI/GestioneModificheDB.vue";
import HomeChat from "../views/CHAT/Home.vue";
import ArticoloAlt from "@/views/PRODUCTION/Articolo/ArticoloAlt.vue";
import ArticoloDetails from "../views/PRODUCTION/Articolo/ArticoloDetails.vue";
import Prelievo from "../views/PRODUCTION/Prelievo/Prelievo";
import Registrazione from "../views/PRODUCTION/Registrazione/Registrazione";
import Magazzino from "../views/PRODUCTION/Magazzino/Magazzino";
import ControlloDDT from "../views/PRODUCTION/Magazzino/ControlloDDT.vue";
import PackageList from "../views/PRODUCTION/Packaging/PackagingList";
import PackageDetail from "../views/PRODUCTION/Packaging/PackageItemDetail";
import AllegatiLista from "../views/PRODUCTION/AllegatiCsvorxslx/AllegatiLista.vue";
import Produzione2 from "../views/PRODUCTION/ProduzioneOnline/Produzione2.vue";
import Produzione from "../views/PRODUCTION/Produzione/Produzione.vue";
import Controllo from "../views/PRODUCTION/Controllo/Controllo.vue";
import Impostazioni from "../views/PRODUCTION/Impostazioni/Impostazioni.vue";
import Avanzamento from "../views/PRODUCTION/Avanzamento/Avanzamento.vue";
import AvanzamentoInsitAdapter from "../views/PRODUCTION/Avanzamento/AvanzamentoInsitAdapter.vue";
import Anagrafiche from "../views/PRODUCTION/Anagrafiche/Anagrafiche.vue";
import Binding from "../views/PRODUCTION/AllegatiCsvorxslx/ImportCsvToDb.vue";
import Manutenzione from "../views/MANUTENZIONE/Manutenzione.vue";
import QuickMaintenance from "../views/QUICKMANUTENZIONE/Quickmanutenzione.vue";
import ManutenzioneRichieste from "../views/MANUTENZIONE/ManutenzioneRichieste.vue";
import ManutenzioneInterventi from "../views/MANUTENZIONE/ManutenzioneInterventi.vue";
import ManutenzioneRegole from "../views/MANUTENZIONE/ManutenzioneRegole.vue";
import ManutenzioneAttivita from "../views/MANUTENZIONE/ManutenzioneAttivita.vue";
import ManutenzioneAnagrafiche from "../views/MANUTENZIONE/ManutenzioneAnagrafiche.vue";
import ManutenzioneGestioneLuoghi from "../views/MANUTENZIONE/ManutenzioneGestioneLuoghi.vue";
import ManutenzioneRecursiva from "../views/MANUTENZIONE/ManutenzioneRecursiva.vue";
import GestioneMacchinari from "../views/MANUTENZIONE/GestioneMacchinari.vue";
import MedicalDashboard from "../views/MEDICAL/Dashboard";
import MedicalHome from "../views/MEDICAL/Home";
import MedicalDettaglio from "../views/MEDICAL/Dettaglio";
import Richieste from "../views/MEDICAL/Richieste.vue";
import Attivita from "../views/MEDICAL/Attivita.vue";
import LayoutEditor from "../views/LAYOUT/layout.vue";
//import CheckHome from "../views/CHECK2/Dashboard";
//import Quiz from "../views/CHECK2/Quiz.vue";
//import QuizDetail from "../components/CHECK2/Quickquiz/QuizDetail.vue";
//import FlowDetail from "../views/CHECK2/FlowDetail.vue";
//import Autorizzazioni from "../views/CHECK2/Autorizzazioni.vue";
//import TabellaTest from "../views/CHECK2/TabellaTest.vue";
import FrameCheckHome from "../views/CHECK2/FrameCheckHome.vue";

import FrameCheckQuiz from "../views/CHECK2/FrameCheckQuiz.vue";
import FrameCheckDossier from "../views/CHECK2/FrameCheckDossier.vue";
import FrameCheckEsecuzioneDossier from "../views/CHECK2/FrameCheckEsecuzioneDossier.vue";
import FrameCheckAutorizzazioni from "../views/CHECK2/FrameCheckAutorizzazioni.vue";
import FrameCheckTabellaTest from "../views/CHECK2/FrameCheckTabellaTest.vue";

import Plant from "../views/PLANT/Plant.vue";
import Ganttview from "../views/GANTT/Gantt.vue";
import ConsuntivoRisorse from "../views/GANTT/ConsuntivoRisorse.vue";
// import EditTicket from "../views/TICKET/EditTicket.vue";
import SingleTicket from "../components/TICKET/SingleTicket.vue";
import HomeTicket from "../views/TICKET/HomeTicket.vue";

import Panoramica from "../components/AMMINISTRAZIONE/Panoramica.vue";
import GenerazioneQrOspite from "../components/AMMINISTRAZIONE/GenerazioneQrOspite.vue";
import PanoramicaNew from "../components/AMMINISTRAZIONE/PanoramicaNew.vue";
import GestioneAziende from "../components/AMMINISTRAZIONE/GestioneAziende.vue";
import GestioneAziendaExtra from "../components/AMMINISTRAZIONE/GestioneAziendaExtra.vue";
import GestioneModuli from "../components/AMMINISTRAZIONE/GestioneModuli.vue";
import GestioneModuliAziende from "../components/AMMINISTRAZIONE/GestioneModuliAziende.vue";
import GestioneModuliMenu from "../components/AMMINISTRAZIONE/GestioneModuliMenu.vue";
import GestioneProfili from "../components/AMMINISTRAZIONE/GestioneProfili.vue";
import GestioneUtenti from "../components/AMMINISTRAZIONE/GestioneUtenti.vue";
import GestioneAccount from "../components/AMMINISTRAZIONE/GestioneAccount.vue";
import GestioneLayout from "../components/AMMINISTRAZIONE/GestioneLayout.vue";
import GestioneHeaderFiltri from "../components/AMMINISTRAZIONE/HEADER_FILTRI/GestioneHeaderFiltri.vue";


import DashboardTools from "../views/TOOLS/Dashboardtools.vue";
import GestionePriorita from "../views/TOOLS/Gestionepriorita.vue";
import ListaAttivitaV from "../views/TOOLS/ListaAttivitaV.vue";
import Plan from "../views/TOOLS/Plan.vue";
import Logistica from "../views/TOOLS/Produzione_logistica.vue";
import ContoLavoro from "../views/TOOLS/LOGISTICA/Conto_lavoro.vue";
import IngressoMateriale from "../views/TOOLS/LOGISTICA/Ingresso_materiale.vue";
import UscitaMateriale from "../views/TOOLS/LOGISTICA/Uscita_materiale.vue";
import ProductionAuth from "../views/TOOLS/ProductionAuth/ProductionAuth.vue";
import ProgettiTicket from "../views/TOOLS/ProgettiTicket.vue";
import AmbitiTicket from "../views/TOOLS/AmbitiTicket.vue";
import Packaging from "../views/TOOLS/LOGISTICA/Packaging.vue";
import ModuloNuovo from "../views/TOOLS/ModuloNuovo.vue";
import Benestare from "../views/TOOLS/BENESTARE/Benestare.vue";
import CicloAutoControllo from "../views/TOOLS/BENESTARE/CicloAutocontrollo.vue";
import PianoControlloModuloNuovo from "../views/TOOLS/BENESTARE/PianoControllo.vue";
import DashboardLogistica from "../views/LOGISTICA/Dashboard";
import PackingList from "../views/LOGISTICA/PackingList";
import PackingListDettaglio from "../views/LOGISTICA/PackingListDettaglio";
import Graph from "@/views/GRAPH/QuickGraphs.vue";

import TabellaImport from "@/views/IMPORT/TabellaImport.vue";
import DashboardImport from "@/views/IMPORT/Dashboard.vue";
import CompetenzeList from "../views/COMPETENZE/CompetenzeList.vue";
import Presenze from "../views/PRESENZE/presenze.vue";
import Inventario from "../views/PRODUCTION/INVENTARIO/Inventario.vue";
import TabellaMezzi from "../components/LOGISTICA/TabellaMezzi.vue";
import Geolocalizzazione from "../components/LOGISTICA/Geolocalizzazione.vue";
import CicloStandard from "../components/PRODUCTION/Impostazioni/CicloStandardDettaglioNew.vue";
// import VideoChat from "../views/VIDEOCHAT/Videochat.vue";
import Chat from "../views/VIDEOCHAT/Chat.vue";

import ReportManager from "../components/REPORT/ReportManager.vue";

import NavalRepair from "@/views/NAVALREPAIR/NavalRepair.vue";
import GestioneSintetica from "@/views/NAVALREPAIR/GestioneSintetica.vue";
import DGAnagrafiche from "@/views/NAVALREPAIR/DGAnagrafiche.vue";
import DGGestioneLF from "@/views/NAVALREPAIR/DGGestioneLF.vue";
import DGListaInterventi from "@/views/NAVALREPAIR/DGListaInterventi.vue";
import Calendar from "@/views/MANUTENZIONE/Calendar.vue";
import TabellaListaInterventi from "@/components/MANUTENZIONE/TabellaListaInterventi.vue";

import ElectricalMarine from "@/views/ELECTRICALMARINE/ElectricalMarine.vue";
import EMDistinta from "@/views/ELECTRICALMARINE/EMDistinta.vue";
import EMLayoutAdapter from "@/views/ELECTRICALMARINE/EMLayoutAdapter.vue";
import EMProduzioneLayoutAdapter from "@/views/ELECTRICALMARINE/EMProduzioneLayoutAdapter.vue";
import EMListaPicking from "@/views/ELECTRICALMARINE/EMListaPicking.vue";
import EMChecklist from "@/views/ELECTRICALMARINE/EMChecklist.vue";
import EMAnagraficaBarche from "@/views/ELECTRICALMARINE/EMAnagraficaBarche.vue";
import EMPdfConvert from "@/views/ELECTRICALMARINE/EMPdfConvert.vue";
import EMArticolo from "@/views/ELECTRICALMARINE/EMArticolo.vue";
import EMDiario from "@/views/ELECTRICALMARINE/EMDiario.vue";
import EMImpostazioni from "@/views/ELECTRICALMARINE/EMImpostazioni.vue";
import EMAvanzamentoAdapter from "@/views/ELECTRICALMARINE/EMAvanzamentoAdapter.vue";
//import EMGestioneFamiglie from "../views/ELECTRICALMARINE/EMGestioneFamiglie.vue";

import OMPPdfConvert from "@/views/PRODUCTION/ProduzioneOnline/OMPPdfConvert.vue";

import Geolocation from "../components/GEOLOCATION/Geolocation.vue";
import Ocr from "../components/OCR/Ocr.vue";

import AnagraficaQuickConnext from "../components/INDUSTRIA_4.0/Anagrafica Quickconnext Box/AnagraficaQuickConnext.vue";
import SinotticoQuickConnext from "../components/INDUSTRIA_4.0/Sinottico/SinotticoQuickConnext.vue";
import ConfigurazioneGeneraleQuickConnext from "../components/INDUSTRIA_4.0/ConfigurazioneGeneraleQuickConnext.vue";
import GestioneAggiornamentiQuickconnext from "../components/INDUSTRIA_4.0/Gestione Aggiornamenti/GestioneAggiornamentiQuickconnext.vue";
import ListaMacchine from "../components/INDUSTRIA_4.0/Gestione Configurazione/ListaMacchine.vue";

import QuickLabelTartuflanghe from "@/views/LABEL/QuickLabelTartuflanghe.vue";
import QuickLabelPartner from "@/views/LABEL/QuickLabelPartner.vue";

import EditMagazzinoView from "../views/MAGAZZINO/EditMagazzinoView.vue";
import EditUbicazioneView from "../views/MAGAZZINO/EditUbicazioneView.vue";
import EditUbicazionePadreView from "../views/MAGAZZINO/EditUbicazionePadreView.vue";
import GiacenzeMagazzinoView from "../views/MAGAZZINO/GiacenzeMagazzinoView.vue";
import MovimentiMagazzinoView from "../views/MAGAZZINO/MovimentiMagazzinoView.vue";
import HomeMagazzino from "../views/MAGAZZINO/HomeMagazzino.vue";
import TrasferimentiMagazzino from "../views/MAGAZZINO/TrasferimentiMagazzino.vue";

import Layout from "../views/PRODUCTION/Avanzamento/LayoutView.vue";

import CRISTALCarrelloCristal from "@/views/PRODUCTION/Produzione/ProduzioneCristal/CRISTALCarrelloCristal.vue";
import ProduzioneInsit from "@/views/PRODUCTION/ProduzioneInsit/ProduzioneInsit.vue";
import StandardProduzioneLayoutAdapter from "@/views/PRODUCTION/ProduzioneLayout/StandardProduzioneLayoutAdapter.vue";
import ProdDistintaAvanzamentoAdapter from "@/views/PRODUCTION/ProduzioneDistintaAvanzamento/ProdDistintaAvanzamentoAdapter.vue";
import ProdTartuAdapter from "@/views/PRODUCTION/ProduzioneTartuflanghe/ProdTartuAdapter.vue";

import HomePicking from "@/views/PICKING/HomePicking.vue";
import PickingSegnalazioni from "@/views/PICKING/PickingSegnalazioni.vue";
import DDTView from "@/views/MAGAZZINO/DDTView.vue";
import DDTDettaglioView from "@/views/MAGAZZINO/DDTDettaglioView.vue";
import PickingView from "@/views/PICKING/PickingView.vue";
import AddPickingView from "@/views/PICKING/AddPickingView.vue";

import IstruzioniDiLavoro from "@/views/PRODUCTION/IstruzioniLavoro/Istruzioni.vue";
import TabellaCustomAdapter from "@/components/TABELLA_CUSTOM/TabellaCustomAdapter.vue";

import Schedulatore from "@/views/SCHEDULATORE/Schedulatore.vue";
import Sched_esterno from "@/views/SCHEDULATORE_EG/Sched_esterno.vue";
import Gantt_new from "@/views/GANTT_NEW/Gantt_new.vue";

import ConsuntivoQuery from "@/views/LABEL/ConsuntivoQuery.vue";

import PanoramicaEtichettePartner from "@/views/LABEL/PanoramicaEtichettePartner.vue";

import TabellaEmail from "@/views/EMAIL/TabellaEmail.vue";
import InvioEmail from "@/views/EMAIL/InvioEmail.vue";

import MacchinariMagazzino from "@/views/MAGAZZINO/MacchinariMagazzino.vue";
import EventView from "@/views/EVENT/event.vue";

import AllegatiModuli from "@/views/TOOLS/AllegatiModuli.vue";
import MagazzinoIngresso from "@/views/MAGAZZINO/MagazzinoIngresso.vue";
import HomeNotice from "@/components/QNOTICE/HomeNotice.vue";
import NotifichePush from "@/components/QNOTICE/NotifichePush.vue";
import AvvisiLogin from "@/components/QNOTICE/AvvisiLogin.vue";
import TaskPeriodici from "@/components/QNOTICE/TaskPeriodici.vue";
import QNotice from "@/views/QNOTICE/QNotice.vue";
import DashboardOrdini from "@/views/CREAZIONE_SF/DashboardOrdini.vue";
import Segnalazioni from "@/views/PRODUCTION/ProduzioneOnline/Segnalazioni.vue";
import QuickLogistic from "@/views/QUICKLOGISTIC/QuickLogistic.vue";
import QLServizi from "@/components/QUICKLOGISTIC/QLServizi.vue";
import QLServiziFerrara from "@/components/QUICKLOGISTIC/QLServiziFerrara.vue";
import QLAutisti from "@/components/QUICKLOGISTIC/QLAutisti.vue";
import QLVeicoli from "@/components/QUICKLOGISTIC/QLVeicoli.vue";
import QLCassoni from "@/components/QUICKLOGISTIC/QLCassoni.vue";
import QLArticolo from "@/components/QUICKLOGISTIC/QLArticolo.vue";
import QLConfig from "@/components/QUICKLOGISTIC/QLConfig.vue";
import QLCalendariTreeview from "@/components/QUICKLOGISTIC/QLCOMPONENTS/QLConfig/QLCalendariTreeview.vue";
import LayoutEcogreenAdapter from "@/components/QUICKLOGISTIC/LayoutEcogreenAdapter.vue";
import ProduzioneLayoutEcogreenAdapter from "@/components/QUICKLOGISTIC/ProduzioneLayoutEcogreenAdapter.vue";
import PopupNotifica from "@/components/NOTIFICHE/PopupNotifica.vue";
import GestioneScadenze from "@/views/GestioneScadenze.vue";
import RecuperoPassword from "@/views/RecuperoPassword.vue";
import GetSecureDocuments from "@/views/GetSecureDocuments.vue";
import ConfermaRiunione from "@/views/ConfermaRiunione.vue";
import Allegati from "@/views/Allegati.vue";
//import GraphNoAuth from "@/views/GraphNoAuth/GraphNoAuth.vue"

Vue.use(VueRouter);
// Controlli permessi per QuickProduction
const checkGenerale = (id_modulo_menu) => {
    let menu_presente = false;
    store.state.menu_sx.forEach((elem) => {
        if (elem.id_modulo_menu === id_modulo_menu) {
            menu_presente = true;
        }
    });
    if (menu_presente === true) {
        redirectToDestination;
    } else {
        redirectToSource;
    }
};
const checkGeneraleDx = (titleModulo) => {
    let menu_presente = false;
    if (
        localStorage.moduli_dx !== undefined &&
        localStorage.moduli_dx !== "undefined" &&
        JSON.parse(localStorage.moduli_dx)[titleModulo] != "undefined"
    ) {
        menu_presente = true;
    }
    if (menu_presente === true) {
        redirectToDestination;
    } else {
        redirectToSource;
    }
};

const redirectToDestination = (to, from, next) => {
    next();
};
const redirectToSource = (to, from, next) => {
    next(from.path);
};
const routes = [
    {
        path: "*",
        redirect: "/login",
    },
    {
        path: "/",
        redirect: "/login",
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
    },
    {
        path: "/recupero",
        name: "RecuperoPassword",
        component: RecuperoPassword,
    },
    {
        path: "/getsecuredocuments/:prefisso/:id",
        name: "GetSecureDocuments",
        component: GetSecureDocuments,
        props: true
    },
    {
        path: "/recupero/:obbligatorio",
        name: "RecuperoPassword",
        component: RecuperoPassword,
        props: true,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/riunione/:obbligatorio",
        name: "ConfermaRiunione",
        component: ConfermaRiunione,
        props: true,
    },
    {
        path: "/allegati/:obbligatorio",
        name: "Allegati",
        component: Allegati,
        props: true,
    },
    //#region Gestione Presenze
    {
        path: "/presenze/dashboard",
        name: "Presenze",
        component: Presenze,
        props: true,
        meta: {
            requiresAuth: true,
        },
    },

    //#endregion

    /*{
        path: "/GraphNoAuth/:encData",
        name: "GraphNoAuth",
        component: GraphNoAuth,
        props: true,
        meta: {
            requiresAuth: false,
        },
    },*/

    {
        path: "/home",
        component: Home,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "/",
                redirect: "/home/dashboard",
            },
            {
                path: "/home/dashboard",
                name: "Dashboard",
                component: Dashboard,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/module/:component",
                name: "WindowFrame",
                component: WindowFrame,
                meta: {
                    requiresAuth: true,
                },
                props: true,
            },
            {
                path: "/home/module/:component/:route",
                name: "WindowFrame",
                component: WindowFrame,
                meta: {
                    requiresAuth: true,
                },
                props: true,
            },
            {
                path: "/home/microtest",
                name: "Microtest",
                component: MicroTest,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            {
                path: "/home/notifica",
                name: "Notifica",
                component: PopupNotifica,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },

            //#region Notifiche

            {
                path: "/home/notifiche",
                name: "Notifiche",
                component: Notifiche,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },

            //#endregion
            //#region Chat
            {
                path: "/home/chat",
                name: "Chat",
                component: HomeChat,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region Profili-Azienda-Utenti
            {
                path: "/home/gestioneprofilo",
                name: "GestioneProfilo",
                component: GestioneProfilo,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/gestioneazienda",
                name: "GestioneAzienda",
                component: GestioneAzienda,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/gestioneutenti",
                name: "GestioneUtenti",
                component: GestioneUtentiSettings,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/gestionemodifichedb",
                name: "GestioneModificheDB",
                component: GestioneModificheDB,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/pdfconvert",
                name: "EMPdfConvert",
                component: EMPdfConvert,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/ompdf",
                name: "OMPPdfconvert",
                component: OMPPdfConvert,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/account",
                name: "GestioneAccount",
                component: GestioneAccount,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            {
                path: "/home/competenze",
                name: "Competenze",
                component: CompetenzeList,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            //#region Ticket
            {
                path: "/home/ticket",
                name: "TicketList",
                component: HomeTicket,
                beforeEnter: checkGeneraleDx("TICKET"),
                props: {
                    assistenza: 0,
                },
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/ticketassistenza",
                name: "TicketListAssistenza",
                component: HomeTicket,
                beforeEnter: checkGeneraleDx("TICKETA"),
                props: {
                    assistenza: 1,
                },
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/ticket/:id",
                name: "SingleTicket",
                component: SingleTicket,
                beforeEnter: checkGeneraleDx("TICKETA"),
                props: {
                    assistenza: 0,
                },
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/ticketassistenza/:id",
                name: "SingleTicketAssistenza",
                component: SingleTicket,
                beforeEnter: checkGeneraleDx("TICKETA"),
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione",
                name: "Panoramica",
                component: Panoramica,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazionenew",
                name: "PanoramicaNew",
                component: PanoramicaNew,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione/gestioneprofili",
                name: "GestioneProfiliAmministrazione",
                component: GestioneProfili,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione/gestioneutenti",
                name: "GestioneUtentiAmministrazione",
                component: GestioneUtenti,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione/gestionemoduli",
                name: "GestioneModuliAmministrazione",
                component: GestioneModuli,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione/gestionemoduliaziende",
                name: "GestioneModuliAziendeAmministrazione",
                component: GestioneModuliAziende,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione/gestionemodulimenu",
                name: "GestioneModuliMenuAmministrazione",
                component: GestioneModuliMenu,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione/gestioneaziende",
                name: "GestioneAziendeAmministrazione",
                component: GestioneAziende,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione/qrguest",
                name: "GenerazioneQrOspite",
                component: GenerazioneQrOspite,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione/aziendaextra",
                name: "GestioneAziendaExtra",
                component: GestioneAziendaExtra,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione/authmenu",
                name: "ProductionAuth",
                component: ProductionAuth,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione/progettiticket",
                name: "ProgettiTicket",
                component: ProgettiTicket,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione/ambititicket",
                name: "AmbitiTicket",
                component: AmbitiTicket,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione/GestioneLayout",
                name: "GestioneLayout",
                component: GestioneLayout,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/amministrazione/gestioneheaderfiltri",
                name: "GestioneHeaderFiltri",
                component: GestioneHeaderFiltri,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/tools/dashboardtools",
                name: "Dashboardtools",
                component: DashboardTools,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/tools/gestioneprofili",
                name: "GestioneProfili",
                component: GestioneProfili,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/tools/gestioneutenti",
                name: "GestioneUtentiTools",
                component: GestioneUtenti,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/tools/gestionemoduli",
                name: "GestioneModuli",
                component: GestioneModuli,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/tools/gestionemoduliaziende",
                name: "GestioneModuliAziende",
                component: GestioneModuliAziende,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/tools/gestioneaziende",
                name: "GestioneAziende",
                component: GestioneAziende,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/tools/gestionepriorita",
                name: "GestionePriorita",
                component: GestionePriorita,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/tools/listaattivita",
                name: "ListaAttivitaV",
                component: ListaAttivitaV,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/tools/plan",
                name: "Plan",
                component: Plan,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/tools/modulo_nuovo",
                name: "ModuloNuovo",
                component: ModuloNuovo,
                props: true,
                meta: {
                    requiresAuth: true,
                },
                children: [
                    {
                        path: "/home/tools/modulo_nuovo/benestare",
                        name: "Benestare",
                        component: Benestare,
                        props: true,
                        meta: {
                            requiresAuth: true,
                        },
                    },
                    {
                        path: "/home/tools/modulo_nuovo/ciclo_autocontrollo",
                        name: "CicloAutoControllo",
                        component: CicloAutoControllo,
                        props: true,
                        meta: {
                            requiresAuth: true,
                        },
                    },
                    {
                        path: "/home/tools/modulo_nuovo/piano_controllo",
                        name: "PianoControlloModuloNuovo",
                        component: PianoControlloModuloNuovo,
                        props: true,
                        meta: {
                            requiresAuth: true,
                        },
                    },
                ],
            },

            //#region QuickManutenzione
            {
                path: "/home/quickmaintenance",
                name: "QuickMaintenance",
                component: QuickMaintenance,
                meta: {
                    requiresAuth: true,
                },
                children: [],
            },
            {
                path: "/home/quickmaintenance/interventi",
                name: "Interventi",
                component: () =>
                    import(
                        "../components/QUICKMANUTENZIONE/Interventi/InterventiTabella.vue"
                    ),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/quickmaintenance/pianificazione",
                name: "Pianificazione",
                component: () =>
                    import(
                        "../components/QUICKMANUTENZIONE/Pianificazione/PianificazioneTabella.vue"
                    ),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/quickmaintenance/richieste",
                name: "RichiesteMaintenance",
                component: () =>
                    import(
                        "../components/QUICKMANUTENZIONE/Richieste/Richiesta.vue"
                    ),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/quickmaintenance/macchine",
                name: "Macchina",
                component: () =>
                    import("../views/QUICKMANUTENZIONE/Macchine.vue"),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/quickmaintenance/:orderId",
                name: "UpdateVehicleMaintenance",
                // component: UpdateVehicleDetail,
                component: () =>
                    import(
                        "../views/QUICKMANUTENZIONE/UpdateVehicleDetail.vue"
                    ),
                meta: {
                    requiresAuth: true,
                },
            },

            // #endregion

            //#region Logistica
            {
                path: "/home/tools/logistica",
                name: "Logistica",
                component: Logistica,
                props: true,
                meta: {
                    requiresAuth: true,
                },
                children: [
                    {
                        path: "/home/tools/logistica/packaging",
                        name: "Packaging",
                        component: Packaging,
                        props: true,
                        meta: {
                            requiresAuth: true,
                        },
                    },
                    {
                        path: "/home/tools/logistica/ingresso_materiale",
                        name: "IngressoMateriale",
                        component: IngressoMateriale,
                        props: true,
                        meta: {
                            requiresAuth: true,
                        },
                    },
                    {
                        path: "/home/tools/logistica/uscita_materiale",
                        name: "UscitaMateriale",
                        component: UscitaMateriale,
                        props: true,
                        meta: {
                            requiresAuth: true,
                        },
                    },
                    {
                        path: "/home/logistica/contolavoro",
                        name: "ContoLavoro",
                        component: ContoLavoro,
                        props: true,
                        meta: {
                            requiresAuth: true,
                        },
                    },
                ],
            },
            //#endregion

            //#region Manutenzione
            {
                path: "/home/manutenzione/main",
                name: "ManutenzioneMain",
                component: Manutenzione,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/manutenzione/richieste",
                name: "ManutenzioneRichieste",
                component: ManutenzioneRichieste,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/manutenzione/interventi",
                name: "ManutenzioneInterventi",
                component: ManutenzioneInterventi,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/manutenzione/regole",
                name: "ManutenzioneRegole",
                component: ManutenzioneRegole,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/manutenzione/attivita",
                name: "ManutenzioneAttivita",
                component: ManutenzioneAttivita,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/manutenzione/anagrafiche",
                name: "ManutenzioneAnagrafiche",
                component: ManutenzioneAnagrafiche,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/manutenzione/gestionesedifornitori",
                name: "ManutenzioneGestioneLuoghi",
                component: ManutenzioneGestioneLuoghi,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/manutenzione/manutenzionerecursiva",
                name: "ManutenzioneRecursiva",
                component: ManutenzioneRecursiva,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/manutenzione/gestionemacchinari",
                name: "GestioneMacchinari",
                component: GestioneMacchinari,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region Production
            {
                path: "/home/production/articolo",
                name: "Articolo",
                component: () =>
                    import("../views/PRODUCTION/Articolo/Articolo.vue"),
                beforeEnter: checkGenerale(2),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/magazzinoingresso",
                name: "MagazzinoIngresso",
                component: MagazzinoIngresso,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/articoloold",
                name: "ArticoloAlt",
                component: ArticoloAlt,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/articolodetails/:id",
                name: "ArticoloDetails",
                component: ArticoloDetails,
                beforeEnter: checkGenerale(2),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production",
                name: "Production Dashboard",
                component: () =>
                    import(
                        "../views/PRODUCTION/ProductionDash/ProductionDash.vue"
                    ),
                // component: ProductionDashboard,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/macchina",
                name: "VehicleDetail",
                component: () =>
                    import("../views/PRODUCTION/Macchine/VehicleDetail.vue"),
                beforeEnter: checkGenerale(3),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/macchinanuovo/:id_modulo_menu",
                name: "MacchinaNuovo",
                props: true,
                component: MacchinaNuovo,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/ordini",
                name: "Ordini",
                component: () =>
                    import("../views/PRODUCTION/Ordini/TabellaOrdini.vue"),
                // beforeEnter: checkGenerale(121),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/materiaprima",
                name: "MateriaPrima",
                component: () =>
                    import(
                        "../components/PRODUCTION/MateriaPrima/MateriaPrima.vue"
                    ),
                // beforeEnter: checkGenerale(121),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/prelievo",
                name: "Prelievo",
                component: Prelievo,
                beforeEnter: checkGenerale(11),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/famigliearticolo",
                name: "FamiglieArticolo",
                component: () =>
                    import(
                        "../views/PRODUCTION/FamiglieArticolo/FamiglieArticoloEMAdapter.vue"
                    ),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/selezionemultipla",
                name: "SelezioneMultipla",
                component: () =>
                    import(
                        "../views/PRODUCTION/SelezioneMultipla/SelezioneMultiplaEMAdapter.vue"
                    ),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/selezionemultiplaqp",
                name: "SelezioneMultipla",
                component: () =>
                    import(
                        "../views/PRODUCTION/SelezioneMultipla/SelezioneMultiplaPRODAdapter.vue"
                    ),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/magazzino",
                name: "Magazzino",
                component: Magazzino,
                beforeEnter: checkGenerale(11),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/magazzino/controlloddt",
                name: "ControlloDDT",
                component: ControlloDDT,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/registerazione",
                name: "Registrazione",
                component: Registrazione,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/pianocontrollo",
                name: "PianoControllo",
                // component: Qualita,
                component: () =>
                    import("../views/PRODUCTION/Qualita/Qualita.vue"),
                beforeEnter: checkGenerale(10),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/packaging",
                name: "PackageList",
                component: PackageList,
                beforeEnter: checkGenerale(9),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/commesa",
                name: "commessa",
                // component: CommessaLista,
                component: () =>
                    import("../views/PRODUCTION/Commesa/CommessaList.vue"),
                beforeEnter: checkGenerale(8),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/qualita",
                name: "Qualita",
                component: () =>
                    import("../views/PRODUCTION/Qualita/Qualita.vue"),
                // component: Qualita,
                beforeEnter: checkGenerale(9),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/benestare",
                name: "Benestare",
                component: () =>
                    import("../views/PRODUCTION/BenestareInsit/BenestareInsit.vue"),
                // component: Qualita,
                beforeEnter: checkGenerale(9),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/cicloautocontrollodetail",
                name: "CicloAutoControlloDetail",
                // component: CicloAutoControlloDetail,
                component: () =>
                    import(
                        "../components/Qualita/CicloAutoControllo/CicloAutocontrolloDetail.vue"
                    ),
                beforeEnter: checkGenerale(9),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/benestaredetail",
                name: "BenestareDetail",
                // component: BenestareDetail,
                component: () =>
                    import(
                        "../components/Qualita/Benestare/BenestareDetail.vue"
                    ),
                beforeEnter: checkGenerale(9),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/pianocontrollodetail",
                name: "PianoControlloDetail",
                // component: PianoControlloDetail,
                component: () =>
                    import(
                        "../components/Qualita/PianoControlo/PianoControlloDetail.vue"
                    ),
                props: true,
                beforeEnter: checkGenerale(9),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/ciclostd",
                name: "cicloStd",
                component: CicloStandard,
                props: true,
                beforeEnter: checkGenerale(9),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/pickinglist",
                name: "pickingList",
                // component: TabellaAvanzzamentoConfirmation,
                component: () =>
                    import(
                        "../components/PRODUCTION/Impostazioni/TabellaAvanzamentoConfirmation.vue"
                    ),
                props: true,
                beforeEnter: checkGenerale(9),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/commesa/:id",
                name: "commessaDetail",
                // component: commessaDetail,
                component: () =>
                    import("../views/PRODUCTION/Commesa/CommesaDashBoard.vue"),
                beforeEnter: checkGenerale(8),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/commessamultipla/:id",
                name: "NuovaCommessaMultipla",
                // component: NuovaCommessaMultipla,
                component: () =>
                    import(
                        "../views/PRODUCTION/Commesa/NuovaCommessaMultipla.vue"
                    ),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/binding/:id",
                name: "Binding",
                component: Binding,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/binding",
                name: "AllegatiLista",
                component: AllegatiLista,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/controllo",
                name: "ControlloProd",
                component: Controllo,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/produzioneonline",
                name: "Produzione2",
                component: Produzione2,
                beforeEnter: checkGenerale(6),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/produzione",
                name: "Produzione",
                component: Produzione,
                beforeEnter: checkGenerale(6),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/impostazioni",
                name: "Impostazioni",
                component: Impostazioni,
                beforeEnter: checkGenerale(4),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/avanzamento",
                name: "Avanzamento",
                component: Avanzamento,
                beforeEnter: checkGenerale(7),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/avanzamentoinsit",
                name: "AvanzamentoInsitAdapter",
                component: AvanzamentoInsitAdapter,
                beforeEnter: checkGenerale(7),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/layout",
                name: "Layout",
                component: Layout,
                beforeEnter: checkGenerale(7),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/anagrafiche",
                name: "Anagrafiche",
                component: Anagrafiche,
                beforeEnter: checkGenerale(5),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/:orderId",
                name: "UpdateVehicle",
                props: true,
                // component: UpdateVehicleDetail,
                component: () =>
                    import(
                        "../views/PRODUCTION/Macchine/UpdateVehicleDetail.vue"
                    ),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/production/packaging/:id",
                name: "PackageDetail",
                component: PackageDetail,
                beforeEnter: checkGenerale(9),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/istruzioni",
                name: "Home_Istr",
                component: IstruzioniDiLavoro,
                meta: {
                    requiresAuth: true,
                },
            },

            //#endregion
            //#region Medical
            {
                path: "/home/medical/home",
                name: "Home",
                component: MedicalHome,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/medical/dashboard",
                name: "Medical Dashboard",
                component: MedicalDashboard,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/medical/dettaglio",
                name: "Dettaglio",
                component: MedicalDettaglio,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            {
                path: "/home/richieste",
                name: "Richieste",
                component: Richieste,
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: "/home/attivita/:id",
                name: "Attivita",
                component: Attivita,
                meta: {
                    requiresAuth: false,
                },
            },
            //#region vecchio QuickCheck monolite
            /*{
        path: "/home/check/dashboard",
        name: "Check Dashboard",
        component: CheckHome,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/home/check/flowdetail/:id",
        name: "FlowDetail",
        component: FlowDetail,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/home/check/autorizzazioni",
        name: "Autorizzazioni",
        component: Autorizzazioni,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/home/check/consuntivotest",
        name: "TabellaTest",
        component: TabellaTest,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/home/check/quiz",
        name: "Quiz",
        component: Quiz,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/home/check/quiz_detail/:id",
        name: "Quiz Detail",
        component: QuizDetail,
        meta: {
          requiresAuth: true,
        },
      },*/
            //#endregion

            // #region nuovo QuickCheck esterno
            {
                path: "/home/check/dashboard",
                name: "Check Dashboard",
                component: FrameCheckHome,
                meta: {
                    requiresAuth: true,
                },
            },

            {
                path: "/home/check/autorizzazioni",
                name: "Autorizzazioni",
                component: FrameCheckAutorizzazioni,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/check/consuntivotest",
                name: "TabellaTest",
                component: FrameCheckTabellaTest,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/check/quiz",
                name: "Quiz",
                component: FrameCheckQuiz,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/check/dossier",
                name: "Dossier",
                component: FrameCheckDossier,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/check/esecuzionedossier",
                name: "Dossier",
                component: FrameCheckEsecuzioneDossier,
                meta: {
                    requiresAuth: true,
                },
            },
            // #endregion

            //#region QuickPlant
            {
                path: "/home/plant/main",
                name: "Plant",
                component: Plant,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region Gantt
            {
                path: "/home/gantt",
                name: "Gantt",
                component: Ganttview,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/consuntivo_risorse",
                name: "ConsuntivoRisorse",
                component: ConsuntivoRisorse,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region Logistica
            {
                path: "/home/logistica/",
                redirect: "/home/logistica/dashboard",
            },
            {
                path: "/home/logistica/dashboard",
                name: "Logistica Dashboard",
                component: DashboardLogistica,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/logistica/packinglist",
                name: "PackingList",
                component: PackingList,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/logistica/packinglistdettaglio/:id",
                name: "PackingListDettaglio",
                component: PackingListDettaglio,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            {
                path: "/home/Inventario/Dashboard",
                name: "Inventario",
                component: Inventario,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/graph",
                name: "Graph",
                component: Graph,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region QuickData
            {
                path: "/home/import",
                name: "DashboardOverviewImport",
                component: DashboardImport,
            },
            {
                path: "/home/import/:id",
                name: "TabellaImport",
                component: TabellaImport,
            },
            //#endregion
            {
                path: "/home/logistica2/",
                name: "TabellaMezzi",
                component: TabellaMezzi,
            },
            {
                path: "/home/logistica2/Geolocalizzazione/:markers",
                name: "Geolocalizzazione",
                component: Geolocalizzazione,
            },

            //#region VideoChat
            // {
            //   path: "/home/videochat",
            //   name: "VideoChat",
            //   component: VideoChat,
            //   props: true,
            //   meta: {
            //     requiresAuth: true,
            //   }
            // },
            {
                path: "/home/videochat",
                name: "VideoChat",
                component: Chat,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/reportmanager",
                name: "ReportManager",
                component: ReportManager,
                props: {
                    admin: true,
                },
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/labelmanager",
                name: "LabelManager",
                component: ReportManager,
                props: {
                    admin: false,
                },
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region NavalRepair
            {
                path: "/home/naval",
                name: "NavalRepair",
                component: NavalRepair,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/naval/gestionesintetica",
                name: "GestioneSintetica",
                component: GestioneSintetica,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/naval/DGAnagrafiche",
                name: "DGAnagrafiche",
                component: DGAnagrafiche,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/naval/DGGestioneLF",
                name: "DGGestioneLF",
                component: DGGestioneLF,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/naval/DGListaInterventi",
                name: "DGListaInterventi",
                component: DGListaInterventi,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/naval/CalendarioEventiLista",
                name: "TabellaListaInterventi",
                component: TabellaListaInterventi,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/naval/CalendarioEventi",
                name: "CalendarioEventi",
                component: Calendar,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/electrical/EMAnagraficaBarche",
                name: "EMAnagraficaBarche",
                component: EMAnagraficaBarche,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region ElectricalMarine
            {
                path: "/home/electrical",
                name: "ElectricalMarine",
                component: ElectricalMarine,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/electrical/EMLayout",
                name: "EMLayoutAdapter",
                component: EMLayoutAdapter,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/electrical/EMProduzione",
                name: "EMProduzioneLayoutAdapter",
                component: EMProduzioneLayoutAdapter,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/electrical/EMDistinta",
                name: "EMDistinta",
                component: EMDistinta,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/electrical/EMListaPicking",
                name: "EMListaPicking",
                component: EMListaPicking,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/electrical/EMArticolo",
                name: "EMArticolo",
                component: EMArticolo,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/electrical/EMChecklist",
                name: "EMChecklist",
                component: EMChecklist,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/electrical/EMDichiarazioni",
                name: "EMDiario",
                component: EMDiario,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            // {
            //   path: "/home/electrical/EMGestioneFamiglie",
            //   name: "EMGestioneFamiglie",
            //   component: EMGestioneFamiglie,
            //   props: true,
            //   meta: {
            //     requiresAuth: true,
            //   },
            // },
            {
                path: "/home/electrical/impostazioni",
                name: "EMImpostazioni",
                component: EMImpostazioni,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/electrical/consuntivi",
                name: "AvanzamentoElectrical",
                component: EMAvanzamentoAdapter,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region QuickConnext
            {
                path: "/home/quickconnext/anagrafica",
                name: "AnagraficaQuickConnext",
                component: AnagraficaQuickConnext,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/quickconnext/sinottico",
                name: "SinotticoQuickConnext",
                component: SinotticoQuickConnext,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/quickconnext/configurazione",
                name: "ConfigurazioneGeneraleQuickConnext",
                component: ConfigurazioneGeneraleQuickConnext,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/quickconnext/gestioneaggiornamenti",
                name: "GestioneAggiornamentiQuickconnext",
                component: GestioneAggiornamentiQuickconnext,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/quickconnext/macchine",
                name: "ListaMacchine",
                component: ListaMacchine,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/geolocation",
                name: "Geolocation",
                component: Geolocation,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/ocr",
                name: "Ocr",
                component: Ocr,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region QuickLabel
            {
                path: "/home/label",
                name: "QuickLabelTartuflanghe",
                component: QuickLabelTartuflanghe,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/labelpartner",
                name: "QuickLabelPartner",
                component: QuickLabelPartner,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region Magazzino
            {
                path: "/home/magazzino",
                name: "home-magazzino",
                component: HomeMagazzino,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/giacenze-magazzino",
                name: "giacenze-magazzino",
                component: GiacenzeMagazzinoView,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/trasferimenti-magazzino/:id",
                name: "trasferimenti-magazzino",
                component: TrasferimentiMagazzino,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/edit-magazzino/:id/:duplicateId?",
                name: "edit-magazzino",
                component: EditMagazzinoView,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/edit-ubicazione/:idMagazzino/:id",
                name: "edit-ubicazione",
                component: EditUbicazioneView,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/edit-ubicazione-padre/:idMagazzino/:id",
                name: "edit-ubicazione-padre",
                component: EditUbicazionePadreView,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/movimenti-magazzino/:id_magazzino/:id_articolo",
                name: "movimenti-magazzino",
                component: MovimentiMagazzinoView,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region AvanzamentoCristal
            {
                path: "/home/cristal-avanzamento",
                name: "CRISTALCarrelloCristal",
                component: CRISTALCarrelloCristal,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region AvanzamentoInsit
            {
                path: "/home/insit-avanzamento",
                name: "ProduzioneInsit",
                component: ProduzioneInsit,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/avanzamentodinamico",
                name: "StandardProduzioneLayoutAdapter",
                component: StandardProduzioneLayoutAdapter,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region DistintaAvanzamentoProduction
            {
                path: "/home/distintavanzamento",
                name: "ProdDistintaAvanzamentoAdapter",
                component: ProdDistintaAvanzamentoAdapter,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region AvanzamentoTartuflanghe
            {
                path: "/home/tartuflanghe-avanzamento",
                name: "ProdTartuAdapter",
                component: ProdTartuAdapter,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region Picking
            {
                path: "/home/picking",
                name: "HomePicking",
                component: HomePicking,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/segnalazioni",
                name: "PickingSegnalazioni",
                component: PickingSegnalazioni,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/DDT",
                name: "DDT",
                component: DDTView,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/DDT/:num_ddt",
                name: "DDTDettaglio",
                component: DDTDettaglioView,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/edit-picking/:id_documento/:num_documento",
                name: "PickingView",
                component: PickingView,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/add-picking",
                name: "AddPickingView",
                component: AddPickingView,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/tabella-custom",
                name: "TabellaCustomAdapter",
                component: TabellaCustomAdapter,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            //#region Picking

            //#region Schedulatore
            {
                path: "/home/schedulatore",
                name: "Schedulatore",
                component: Schedulatore,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion

            //#region Schedulatore ECOGREEN
            {
                path: "/home/schedulatore_EG",
                name: "Schedulatore_EG",
                component: Sched_esterno,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion

            //#region QuickNotice
            {
                path: "/home/notice",
                name: "QuickNotice",
                component: HomeNotice,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/noticelist",
                name: "Notice",
                component: QNotice,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/notifichepush",
                name: "NotifichePush",
                component: NotifichePush,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/avvisilogin",
                name: "AvvisiLogin",
                component: AvvisiLogin,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/taskperiodici",
                name: "TaskPeriodici",
                component: TaskPeriodici,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion
            {
                path: "/home/myanomalie",
                name: "Segnalazioni",
                component: Segnalazioni,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },

            //#region QuickOrder
            {
                path: "/home/order",
                name: "QuickOrder",
                component: DashboardOrdini,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            //#endregion

            {
                path: "/home/gantt_new",
                name: "Gantt_new",
                component: Gantt_new,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/label/consuntivoquery",
                name: "ConsuntivoQuery",
                component: ConsuntivoQuery,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/label/panoramicaetichette",
                name: "PanoramicaEtichettePartner",
                component: PanoramicaEtichettePartner,
            },
            {
                path: "/home/invioemail",
                name: "TabellaEmail",
                component: TabellaEmail,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/setupsmtp",
                name: "InvioEmail",
                component: InvioEmail,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/eventi",
                name: "Event",
                component: EventView,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/allegati_moduli",
                name: "AllegatiModuli",
                component: AllegatiModuli,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/macchinarimagazzino",
                name: "MacchinariMagazzino",
                component: MacchinariMagazzino,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/gestionemodellidocumento",
                name: "GestioneModelliDocumento",
                component: GestioneModelliDocumento,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/layouteditor",
                name: "LayoutEditor",
                component: LayoutEditor,
                props: true,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/home/quicklogistic",
                name: "RadialMenu",
                component: QuickLogistic,
                props: true,
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: "/home/quicklogistic/veicoli",
                name: "Veicoli",
                component: QLVeicoli,
                props: true,
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: "/home/quicklogistic/autisti",
                name: "Autisti",
                component: QLAutisti,
                props: true,
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: "/home/quicklogistic/servizi",
                name: "servizi",
                component: QLServizi,
                props: true,
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: "/home/quicklogistic/serviziferrara",
                name: "servizi",
                component: QLServiziFerrara,
                props: true,
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: "/home/quicklogistic/cassoni",
                name: "Cassoni",
                component: QLCassoni,
                props: true,
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: "/home/quicklogistic/articolo",
                name: "ArticoloLogistic",
                component: QLArticolo,
                props: true,
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: "/home/quicklogistic/config",
                name: "Config",
                component: QLConfig,
                props: true,
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: "/home/quicklogistic/config/calendario_treeview",
                name: "Config",
                component: QLCalendariTreeview,
                props: true,
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: "/home/quicklogistic/layout",
                name: "LayoutEcogreenAdapter",
                component: LayoutEcogreenAdapter,
                props: true,
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: "/home/quicklogistic/avanzamentodinamico",
                name: "ProduzioneLayoutEcogreenAdapter",
                component: ProduzioneLayoutEcogreenAdapter,
                props: true,
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: "/home/scadenze",
                name: "GestioneScadenze",
                component: GestioneScadenze,
                props: true,
                meta: {
                    requiresAuth: false,
                },
            },
        ],
    },

];
const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});
router.beforeEach((to, from, next) => {
    //controllo che l'utente abbia l'auth per entrare
    let jwt_get = localStorage.user_token;
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    console.log(to.path.startsWith("/recupero"));
    if (requiresAuth && !jwt_get && to.path !== "/login" && (!(to.path.startsWith("/recupero")) || !(to.path.startsWith("/getsecuredocuments")))) next("login");
    else if (!requiresAuth && jwt_get && (to.path !== "/login" && !(from.path.startsWith("/recupero")) && !(to.path.startsWith("/riunione")) && !(to.path.startsWith("/allegati")) && !(to.path.startsWith("/getsecuredocuments")))) next("home");
    else {
        if (
            store.state.pagina_attuale == "controllo" &&
            store.state.check_paginaAttuale == 1
        ) {
            store.state.conferma_cambio_rotta = true;
            store.state.rotta_to = to;
            store.state.rotta_from = from;
        } else {
            next();
        }
    }
});
export default router;
